import React, { useContext } from 'react';
import SimpleCheckbox from './SimpleCheckbox';
import AppContext from './AppContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './components/Accordion';

function PokedexFiltersSpecial() {
  const {
    legendariesOnly,
    setLegendariesOnly,
    mythicalsOnly,
    setMythicalsOnly,
    fullyEvolvedOnly,
    setFullyEvolvedOnly,
    babyPokemonOnly,
    setBabyPokemonOnly,
    paradoxPokemonOnly,
    setParadoxPokemonOnly,
    ultraBeastsOnly,
    setUltraBeastsOnly,
  } = useContext(AppContext);

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="special-filter">
        <AccordionTrigger>Special Filter</AccordionTrigger>
        <AccordionContent>
          <SimpleCheckbox
            labelText="Legendaries Only"
            checked={legendariesOnly}
            disabled={false}
            onChange={() => setLegendariesOnly(!legendariesOnly)}
          />
          <SimpleCheckbox
            labelText="Mythical Only"
            checked={mythicalsOnly}
            disabled={false}
            onChange={() => setMythicalsOnly(!mythicalsOnly)}
          />
          <SimpleCheckbox
            labelText="Fully Evolved Only"
            checked={fullyEvolvedOnly}
            disabled={false}
            onChange={() => setFullyEvolvedOnly(!fullyEvolvedOnly)}
          />
          <SimpleCheckbox
            labelText="Baby Pokémon Only"
            checked={babyPokemonOnly}
            disabled={false}
            onChange={() => setBabyPokemonOnly(!babyPokemonOnly)}
          />
          <SimpleCheckbox
            labelText="Ultra Beasts Only"
            checked={ultraBeastsOnly}
            disabled={false}
            onChange={() => setUltraBeastsOnly(!ultraBeastsOnly)}
          />
          <SimpleCheckbox
            labelText="Paradox Pokémon Only"
            checked={paradoxPokemonOnly}
            disabled={false}
            onChange={() => setParadoxPokemonOnly(!paradoxPokemonOnly)}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default PokedexFiltersSpecial;
